<div class="item" [class.clickable]="clickable">
  <div>
    <ng-content></ng-content>
  </div>
  <div *ngIf="clickable" class="arrow-icon">
    <app-icon size="none" name="arrow-right"></app-icon>
  </div>
</div>
